export enum ReservationType {
  DEPOSIT = 1,
  NOW = 2,
  PHONE = 3,
  OPTION = 4
}